<template>
  <div class="fixed-0 overflow-hidden">
    <div class="w-[100%] relative top-[35%] -translate-y-[50%] text-white text-center">
      <h1 class="text-30">404</h1>
      <h2 class="text-18">page not found</h2>
      <div class="flex mt-8 mx-4">
        <van-button @click="$router.replace('/')" class="primaryBtn mx-10">Go back to '/' in {{ count }}s</van-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useLinearCount } from '@/hooks'
  import router from '@/router'

  const { count, isFinished } = useLinearCount(5, 0, 1000, {autoStart: true})
  
  watch(isFinished, (val) => {
    if (val) router.replace('/')
  })
</script>
